// extracted by mini-css-extract-plugin
export var error = "search-results-module--error--5865f";
export var message = "search-results-module--message--a1268";
export var resultDescription = "search-results-module--resultDescription--9c49b";
export var resultLink = "search-results-module--resultLink--25d62";
export var results = "search-results-module--results--3ce09";